import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'tofixed' })
export class ToFixedPipe implements PipeTransform {
   transform( value: number, length: number = 2 ): string {
      return value.toFixed( length );
   }
}
